import { useEffect, useMemo, useRef } from 'react';
/**
 * Хук создающий инстанс ResizeObserver
 * @param callback колбэк который вызывается на изменение размеров обозреваемого объекта
 * @returns инстанс ResizeObserver
 */
export const useResizeObserver = (callback) => {
    const callbackRef = useRef();
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    const observer = useMemo(() => {
        if (typeof ResizeObserver === 'undefined') {
            return;
        }
        return new ResizeObserver(
        // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
        (args, observer) => callbackRef.current?.(args, observer));
    }, []);
    useEffect(() => {
        return () => observer && observer.disconnect();
    }, [observer]);
    return observer;
};
